import { render, staticRenderFns } from "./search-module.vue?vue&type=template&id=1121239b&scoped=true"
import script from "./search-module.vue?vue&type=script&lang=js"
export * from "./search-module.vue?vue&type=script&lang=js"
import style0 from "./search-module.vue?vue&type=style&index=0&id=1121239b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1121239b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1121239b')) {
      api.createRecord('1121239b', component.options)
    } else {
      api.reload('1121239b', component.options)
    }
    module.hot.accept("./search-module.vue?vue&type=template&id=1121239b&scoped=true", function () {
      api.rerender('1121239b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/public/search-module.vue"
export default component.exports